import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Generate or retrieve visitor ID
const getVisitorId = () => {
  let visitorId = localStorage.getItem("tmi_visitor_id");
  if (!visitorId) {
    visitorId = 'v_' + Math.random().toString(36).substr(2, 9) + Date.now().toString(36);
    localStorage.setItem("tmi_visitor_id", visitorId);
  }
  return visitorId;
};

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view
    const trackPageView = async () => {
      try {
        await axios.post(`${API}/analytics/pageview`, {
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          visitor_id: getVisitorId()
        });
      } catch (error) {
        // Silently fail - don't impact user experience
        console.debug("Analytics tracking failed:", error);
      }
    };

    trackPageView();
  }, [location.pathname]);

  return null;
};

export default Analytics;
